import { useSearchParams } from 'react-router-dom';
import { SlidingTabs } from '@/components/ui';
import { PageTitle } from '@/components/ui/PageTitle';
import { Companies } from './Companies';
import { CompanyPlansPage } from './CompanyPlansPage';
import { CompanyDepartmentsPage } from './CompanyDepartmentsPage';

export const CompaniesSection = () => {
	const [searchParams] = useSearchParams();
	const tabParam = searchParams.get('tab');
	const defaultActiveTab =
		tabParam === 'planos'
			? 'planos'
			: tabParam === 'departamentos'
			  ? 'departamentos'
			  : 'empresas';

	const tabs = [
		{
			id: 'empresas',
			label: 'Empresas',
			children: <Companies />,
		},
		{
			id: 'planos',
			label: 'Planos de empresas',
			children: <CompanyPlansPage />,
		},
		{
			id: 'departamentos',
			label: 'Departamentos',
			children: <CompanyDepartmentsPage />,
		},
	];

	return (
		<section className="animate-fade-in space-y-6 px-4 py-6">
			<div className="space-y-1">
				<PageTitle text="Empresas Contratantes" />
				<p className="text-sm text-stone-500">
					Gerencie empresas parceiras, planos empresariais e
					departamentos.
				</p>
			</div>
			<SlidingTabs
				key={defaultActiveTab}
				tabs={tabs}
				defaultActiveTab={defaultActiveTab}
			/>
		</section>
	);
};
